'use client';

import Link from 'next/link';
import { API_HOME_THINGS } from '@/constant/apiRout';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import { getTodayDealEndTime } from '@/utils/getTodayDealEndTime';
import { FlashSalesHeader } from './FlashSalesHeader';
import { FlashSalesSkeleton } from './FlashSalesSkeleton';
import { FlashSalesSlider } from './FlashSalesSlider';

const TodaysDeals = () => {
  const { data: homeThings, isLoading } = useFetcherCSR(API_HOME_THINGS);
  const products = Array.isArray(homeThings?.todays_hot_deals_products)
    ? homeThings.todays_hot_deals_products
    : [];
  const todayEndTime = getTodayDealEndTime();
  const hasTodaysDeals = products.length > 3;

  if (isLoading) return <FlashSalesSkeleton />;

  if (!hasTodaysDeals) {
    return null;
  }

  return (
    <section className="padding-top pb-20 section-bg">
      <div className="container">
        <FlashSalesHeader
          endDate={todayEndTime}
          href="/todays-deals"
          title="Today's Deals"
        />
        <div className="product__wrapper">
          <FlashSalesSlider products={products} />
        </div>

        <div className="d-sm-none text-center mt-4">
          <Link className="trk-btn trk-btn--primary" href="/todays-deals">
            View All
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TodaysDeals;
